module.exports = __webpack_public_path__ + "static/media/heart.69b3940b.png";